
function clearStore(db, storeName) {
  const tx = db.transaction(storeName, 'readwrite');
  const clearRequest = tx.objectStore(storeName).clear();
  clearRequest.onerror = (e) => {
    console.log('Error', e);
  };
}

export default function clear(userId) {
  const request = indexedDB.open(`search_history_${userId}`, 1);
  request.onsuccess = (e) => {
    const db = e.target.result;
    clearStore(db, 'companies');
    clearStore(db, 'customers');
    clearStore(db, 'posts');
    clearStore(db, 'events');
    clearStore(db, 'queries');
  };
}
